export const DATE_FORMAT_SLASHES = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT_SLASHES = 'DD/MM/YYYY HH:mm';

export const DATE_FORMAT_DASHES = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT_DASHES = 'DD-MM-YYYY HH:mm';
